"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('setting-two', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M18.2838 43.1711C14.9327 42.1734 11.9498 40.321 9.58787 37.8668C10.469 36.8225 11 35.4732 11 33.9999C11 30.6862 8.31371 27.9999 5 27.9999C4.79955 27.9999 4.60139 28.0097 4.40599 28.0289C4.13979 26.7275 4 25.38 4 23.9999C4 21.9093 4.32077 19.8936 4.91579 17.9993C4.94381 17.9997 4.97188 17.9999 5 17.9999C8.31371 17.9999 11 15.3136 11 11.9999C11 11.0486 10.7786 10.149 10.3846 9.34986C12.6975 7.19925 15.5205 5.58977 18.6521 4.7229C19.6444 6.66795 21.6667 7.99988 24 7.99988C26.3333 7.99988 28.3556 6.66795 29.3479 4.7229C32.4795 5.58977 35.3025 7.19925 37.6154 9.34986C37.2214 10.149 37 11.0486 37 11.9999C37 15.3136 39.6863 17.9999 43 17.9999C43.0281 17.9999 43.0562 17.9997 43.0842 17.9993C43.6792 19.8936 44 21.9093 44 23.9999C44 25.38 43.8602 26.7275 43.594 28.0289C43.3986 28.0097 43.2005 27.9999 43 27.9999C39.6863 27.9999 37 30.6862 37 33.9999C37 35.4732 37.531 36.8225 38.4121 37.8668C36.0502 40.321 33.0673 42.1734 29.7162 43.1711C28.9428 40.7517 26.676 38.9999 24 38.9999C21.324 38.9999 19.0572 40.7517 18.2838 43.1711Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31Z",
    fill: props.innerFillColor,
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;